<div role="group" class="app-input-container">
    <input *ngIf="!phoneInputMask"
      #inputElement
      class="app-input-element w-100"
      (focus)="setAutocomplete(autocomplete)"
      [formControl]="control"
      [maxLength]="maxLength"
      [type]="type"
      [attr.autocomplete]="autocomplete ? autocomplete : null"

    >
    <input *ngIf="phoneInputMask"
      #inputElement
      class="app-input-element w-100"
      (focus)="setAutocomplete(autocomplete)"
      [formControl]="control"
      [maxLength]="maxLength"
      [type]="type"
      [attr.autocomplete]="autocomplete ? autocomplete : null"
      [inputMask]="phoneMask"
    >
    <span *ngIf="focused && showMaxLength" class="character-counter">{{value.length}}/{{maxLength}}</span>
</div>
